module.exports = __webpack_public_path__ + "img/3.fc4cb985.jpg";